import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

function ServiceWorkerUpdatePrompt() {
  const [updateReady, setUpdateReady] = useState(false);
  const registrationRef = useRef(null);
  const reloadingRef = useRef(false);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (updatedRegistration) => {
        registrationRef.current = updatedRegistration;
        setUpdateReady(true);
      },
    });
  }, []);

  const handleUpdate = () => {
    const waitingWorker = registrationRef.current?.waiting;
    if (!waitingWorker) {
      window.location.reload();
      return;
    }

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadingRef.current) {
        return;
      }
      reloadingRef.current = true;
      window.location.reload();
    });

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <Snackbar
      open={updateReady}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        left: 'auto',
        pointerEvents: 'none',
      }}
    >
      <Alert
        severity="info"
        action={(
          <Button color="inherit" size="small" onClick={handleUpdate}>
            Atualizar
          </Button>
        )}
        sx={{
          alignItems: 'center',
          boxShadow: 'none',
          border: '1px solid currentColor',
          pointerEvents: 'auto',
          '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center',
            py: 0,
          },
          '& .MuiAlert-action': {
            alignItems: 'center',
            pt: 0,
            pb: 0,
          },
        }}
      >
        Nova versão disponível
      </Alert>
    </Snackbar>
  );
}

export default ServiceWorkerUpdatePrompt;
